module.exports = __webpack_public_path__ + "static/media/yellow-candy.6a81bb59.png";